
<b-row align-h="center" justify="center">
  <b-row
    v-if="products.length > 0"
    align-h="center"
    justify="center"
    class="text-center products-list mx-auto"
  >
    <order-product
      v-for="(_, x) in products"
      :key="x"
      v-model="products[x]"
      :rotating-subscription="rotatingSubscription"
      :view-reviews="viewReviews"
    />
  </b-row>

  <b-row v-else-if="loading" key="loading" class="text-center no-products pt-3">
    <b-col xs12>
      <h1>Loading</h1>
      <p>Please wait.</p>
    </b-col>
  </b-row>

  <product-info v-if="viewProductInfo" v-model="viewProductInfo" :view-reviews="viewReviews" />

  <product-reviews v-if="viewProductReviews && viewProductReviews.uuid" v-model="viewProductReviews" />
</b-row>
